/**
 * Copyright © Veeam Software Group GmbH.
 */

import { BackupAgentPolicyRepresentation } from '@veeam-vspc/models/web-controllers';

export type VawTemplateStatuses = BackupAgentPolicyRepresentation;
export const VawTemplateStatuses = BackupAgentPolicyRepresentation;
